// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 590 ? "main" : chunkId) + "." + {"380":"7d1b98c52bbaaec33693","590":"ad762350a2b85195612c"}[chunkId] + ".css";
};